import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import type { DevRoeUsesCategory } from '#shared/lex'

type UsesCategoryValue = Omit<DevRoeUsesCategory.Record, '$type'>


export default /*@__PURE__*/_defineComponent({
  __name: 'new',
  setup(__props) {

definePageMeta({ layout: false })
useHead({ title: 'New uses category - admin - Daniel Roe' })

async function save (value: UsesCategoryValue) {
  await $fetch('/api/admin/uses-categories', { method: 'POST', body: value })
  await navigateTo('/admin/uses')
}

return (_ctx: any,_cache: any) => {
  const _component_AdminUsesCategoryForm = _resolveComponent("AdminUsesCategoryForm")!
  const _component_AdminShell = _resolveComponent("AdminShell")!

  return (_openBlock(), _createBlock(_component_AdminShell, { title: "New uses category" }, {
    default: _withCtx(() => [
      _createVNode(_component_AdminUsesCategoryForm, {
        "submit-label": "Create",
        onSubmit: save
      })
    ]),
    _: 1
  }))
}
}

})